import { render, staticRenderFns } from "./ReviewCustomerActionsComponent.vue?vue&type=template&id=9a5f7a98&"
import script from "./ReviewCustomerActionsComponent.vue?vue&type=script&lang=js&"
export * from "./ReviewCustomerActionsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports